export var SrciButtonSizeEnumsObj = {
    SMALL: "small",
    MEDIUM: "medium",
    BIG: "big",
};
